import {useState} from 'react'
//mintApp imports the entire object containing the necessary functions for the mint website
import {mintApp} from 'C:/Users/UZOR/PycharmProjects/untitled/venv/MysticCharacters_project/nft_frontend/src/MysticCharactersFunctions'
import Buttons from './Buttons'

function Mint(props) {

    const [,setMintState] = useState(1)
    const [mintCount, setMintCount] = useState(1)
    const [clickState, setClickState] = useState(false)
    const [accessMintValue, setAccessMintValue] = useState('')
    const [connectedValue, setConnectedValue] = useState(false)
    const [remainder, setRemainder] = useState((async() => {await mintApp.maxSupply()}).toNumber)
    const [alertError, setAlertError] = useState('')
    const [isCloseAlert, setIsCloseAlert] = useState(false)
    const [mintedMessage, setMintedMessage] = useState('')
    const [mintedMessageString, setMintedMessageString] = useState('')
    const [mintedMessageObject, setMintedMessageOject] = useState()
    const [isCloseMintAlert, setIsCloseMintAlert] = useState(false)
    const [connectButtonTitle, setConnectButtonTitle] = useState('')

    //This is the main function activated when user submits the form by clicking 'MINT'
    const onSubmit = async (e) => {
        e.preventDefault()
        await props.onAdd(mintCount, !clickState)
        setClickState(false)
        //This is a try catch expression which tries to mint the actual ERC-721
        //token. If an error occurs, or user cancels tx, the error is caught
        //without breaking the site
        try {
            const minted = await mintApp.mint(mintCount, props.onFetch())
            setMintedMessageOject(minted)
            setMintedMessageString('You have successfully minted one of the Mystic Creatures')
            console.log(mintedMessageObject)
        }
        catch (err) {
            setMintedMessage(err.toString)
            setMintedMessageString('MetaMask Tx Signature: User denied transaction signature')
        }
        setIsCloseMintAlert(false)
    }

    //This function basically imports from an external function, and sets 2 variables
    //to the values obtained. Also, tries and catches errors on getting connect section's
    //title (which is in header) i.e. document.getElementById(...).innerHTML...
    const accessMintValueFunc = async () => {
        setAccessMintValue(await props.onGetAccessValue())
        setConnectedValue(await props.onCheckDisconnectedVal())
        try {
            setConnectButtonTitle(document.getElementById('connectButton').innerHTML.toString())
        }
        catch (err) {
            setConnectButtonTitle('Connect Wallet')
        }
    }

    //This function does a similar task as 'handleNetworkSwitch()' in the Header.
    //But, this is now down from the MINT section to save user's energy & time
    const changeNetworkFunc2 = async (networkName) => {
        try {
            if (window.ethereum.networkVersion === '5') {
                document.getElementById('connectButton').click()
                document.getElementById('switchButton').click(networkName)
            }
            else {
                document.getElementById('switchButton').click(networkName)
            }
        }
        catch (err) {
            console.log(err)
        }
        setIsCloseAlert(true)
    }

    //This function basically how many ERC-721 tokens are left for a new/existing
    //user to mint on the site i.e. maxSupply() - totalSupply()
    async function mintsRemainderFunc () {
        try {
            setRemainder((await mintApp.maxSupply()) - (await mintApp.totalSupply()))
        }
        catch (err) {
            console.log(err)
            setRemainder(21)
            setAlertError(err)
            setIsCloseAlert(false)
        }
    }

    //This function is embedded in 'x' sign on customized alert box to close it
    function closeMintMessage () {
        setIsCloseMintAlert(!isCloseMintAlert)
        console.log('Mint message closed')
    }

    //This function is embedded in 'x' sign on customized alert box to close it
    function closeErrorFunc () {
        setIsCloseAlert(!isCloseAlert)
        console.log('close')
    }

    return (
        <div className='mint'>
            <ul>
                <h2 id='mint_title'>Mint NFT</h2>
                <div id='mint_box'>
                    <div onMouseOver={mintsRemainderFunc} id='mint_box_items'>
                        <div id='remaining' style={{color: 'beige', fontSize: '22px', paddingLeft: '5vw', paddingRight: '5vw', textAlign: 'center'}}>
                            <h3>Remaining</h3>
                            <h3>{remainder}</h3>
                        </div>
                        <div id='price' style={{color: 'beige', fontSize: '22px', paddingLeft: '5vw', paddingRight: '5vw', textAlign: 'center'}}>
                            <h3>Mint Price</h3>
                            <h3>0.005 ETH</h3>
                        </div>
                    </div>
                    <div id='mint_button'>

                        <form action='#' onSubmit={onSubmit} onMouseOver={accessMintValueFunc}>

                            <select id='amount' onChange={(e) => {setMintCount(e.target.value)}} 
                            style={{fontSize: '22px', fontFamily: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif'}}>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                            </select>
                            <br/>
                            {((connectedValue === true) ?
                                (connectButtonTitle !== 'Connect Wallet' ? 
                                <input id='mint_button_text' type='submit' value='MINT'
                                onClick={(e) => {setMintState(mintCount)}} />:
                                <input id='mint_button_text' type='submit' value='MINT'
                                onClick={(e) => {setMintState(mintCount)}} disabled/>)
                            :
                                (accessMintValue==='disconnect' ? 
                                <input id='mint_button_text' type='submit' value='MINT'
                                onClick={(e) => {setMintState(mintCount)}} 
                                disabled/>:
                                <input id='mint_button_text' type='submit' value='MINT'
                                onClick={(e) => {setMintState(mintCount)}} disabled/>)
                            )
                            }
                        </form>
                    </div>
                </div>
            </ul>
            <ul className='mint_message'>
                {connectedValue === false ?
                    (alertError !== '' && window.ethereum.networkVersion !== '5' ?
                    <div className='alert' style={{display: isCloseAlert ? 'none': 'block'}}>
                        <span className='close-btn' onClick={closeErrorFunc}>
                            &times;
                        </span>
                        Connect to Goerli Test network
                        <Buttons id='connect-btn2' onClick={() => {changeNetworkFunc2('goerli')}} title='Change Network'>Change Network</Buttons>
                    </div>
                    :
                    (alertError === '' && window.ethereum.networkVersion === '5' ?
                        <div className='alert' style={{display: isCloseAlert ? 'none': 'block'}}>
                            <span className='close-btn' onClick={closeErrorFunc}>
                                &times;
                            </span>
                            Connect Your Wallet
                            <Buttons id='connect-btn2' onClick={() => {changeNetworkFunc2('goerli')}} title='Connect'>Change Network</Buttons>
                        </div>
                        :
                        <div style={{display: 'none'}}>
                            <h4>{props.text}</h4>
                        </div>
                        )
                    )
                :
                    (connectButtonTitle === 'Connect Wallet' ?
                        <div className='alert' style={{display: isCloseAlert ? 'none': 'block'}}>
                                <span className='close-btn' onClick={closeErrorFunc}>
                                    &times;
                                </span>
                                Connect Your Wallet
                                <Buttons id='connect-btn2' onClick={() => {changeNetworkFunc2('goerli')}} title='Connect'>Change Network</Buttons>
                        </div>
                    :
                        (mintedMessage !== '' ?
                        <div className='alert' style={{display: isCloseMintAlert ? 'none': 'block'}}>
                            <span className='close-btn' onClick={closeMintMessage}>
                                &times;
                            </span>
                            {mintedMessageString}
                        </div>
                        :
                        <div style={{display: 'none'}}>
                            <h4>{props.text}</h4>
                        </div>
                        )
                    )
                }
            </ul>
        </div>
    )
}

export default Mint